/* eslint-disable react/self-closing-comp */
// @ts-ignore
import React from "react";

import { SvgContainer } from "./svg-container";

export const SmileyIcon = () => {
    return (
        <SvgContainer>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="xMinYMin meet"
                viewBox="0 0 36 36"
            >
                <path
                    fill="#ffffff"
                    fillRule="evenodd"
                    d="M0,18A18,18,0,1,1,18,36,18,18,0,0,1,0,18Zm33.18,0A15.18,15.18,0,1,0,18,33.18,15.17,15.17,0,0,0,33.18,18Z"
                ></path>
                <path
                    fill="#ffffff"
                    fillRule="evenodd"
                    d="M9.28,19.65a1.41,1.41,0,0,1,1.81.84,7.43,7.43,0,0,0,13.82,0,1.41,1.41,0,1,1,2.65,1,10.25,10.25,0,0,1-19.12,0A1.41,1.41,0,0,1,9.28,19.65Z"
                ></path>
                <circle
                    cx="12.21"
                    cy="13.77"
                    r="2.66"
                    fill="#ffffff"
                    fillRule="evenodd"
                ></circle>
                <circle
                    cx="24.1"
                    cy="13.77"
                    r="2.66"
                    fill="#ffffff"
                    fillRule="evenodd"
                ></circle>
            </svg>
        </SvgContainer>
    );
};
